
<svg :width="width" :height="height" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M11.79 11C11.79 10.4477 11.3423 10 10.79 10H5.5L5.38338 10.0067C4.88604 10.0645 4.5 10.4872 4.5 11C4.5 11.5523 4.94772 12 5.5 12H10.79L10.9067 11.9933C11.404 11.9355 11.79 11.5128 11.79 11Z"
    :fill="color"
  />
  <path
    d="M17.355 15C17.355 14.4477 16.9073 14 16.355 14H5.5L5.38338 14.0067C4.88604 14.0645 4.5 14.4872 4.5 15C4.5 15.5523 4.94772 16 5.5 16H16.355L16.4716 15.9933C16.9689 15.9355 17.355 15.5128 17.355 15Z"
    :fill="color"
  />
  <path
    d="M16.355 18C16.9073 18 17.355 18.4477 17.355 19C17.355 19.5128 16.9689 19.9355 16.4716 19.9933L16.355 20H5.5C4.94772 20 4.5 19.5523 4.5 19C4.5 18.4872 4.88604 18.0645 5.38338 18.0067L5.5 18H16.355Z"
    :fill="color"
  />
  <path
    d="M17.355 23C17.355 22.4477 16.9073 22 16.355 22H5.5L5.38338 22.0067C4.88604 22.0645 4.5 22.4872 4.5 23C4.5 23.5523 4.94772 24 5.5 24H16.355L16.4716 23.9933C16.9689 23.9355 17.355 23.5128 17.355 23Z"
    :fill="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16 1C16.0244 1 16.0487 1.00088 16.0727 1.0026C16.3178 0.984942 16.5679 1.05727 16.7695 1.21881L16.8625 1.30337L21.7174 6.30337C21.9713 6.56487 22.0536 6.92952 21.9663 7.25787C21.9883 7.34025 22 7.42681 22 7.51611V30C22 30.5523 21.5523 31 21 31H1C0.447715 31 0 30.5523 0 30V2C0 1.44772 0.447715 1 1 1H16ZM17 4.31601L19.1363 6.51611H17V4.31601ZM2 3H15V6.51611L15.0055 6.66538C15.0818 7.70024 15.9456 8.51611 17 8.51611L20 8.516V29H2V3Z"
    :fill="color"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M32 2C32 1.44772 31.5523 1 31 1H26C25.4477 1 25 1.44772 25 2V23L25.0777 23.3672C26.167 28.4478 27.3078 30.9882 28.5 30.9882C29.6638 30.9882 30.7786 28.5674 31.8444 23.7258L32 23V2ZM27 3H30V5H27V3ZM27 7H30V22.787L29.9553 23H27.0445C27.0407 22.9827 27.037 22.9653 27.0333 22.948L27 22.792V7ZM27.5125 25C27.8099 26.1609 28.1062 27.1102 28.3968 27.8416L28.499 28.091L28.5501 27.9729C28.8583 27.2238 29.1723 26.2304 29.4875 25H27.5125Z"
    :fill="color"
  />
</svg>
